<div class="modal-body" style="width: 1240px">
  <div class="layout-auto-1-auto">
    <div class="grid-auto-1-auto">
      <h4 class="modal-header">{{getRessource('Kommentare')}}&nbsp;</h4>
      <div class="app-width-available">
				<span style="margin-left: 14px" class="typo-small">
					<strong>Schlüssel</strong>
				</span>
        <span style="margin-left: 142px" class="typo-small">
					<strong>Alter Wert</strong>
				</span>
        <span style="margin-left: 336px" class="typo-small">
					<strong>Neuer Wert</strong>
				</span>
      </div>
      <div class="grid-auto-1-auto app-width-fit-content typo-center">
        <div class="app-space-right">
          <img class="app-user_avatar__smaller"
               [src]='appData.userData?.idProfilePicture || appData.defaultProfilePicture'
               alt="profilpic" (click)="close();appData.showSettings()"
          />
        </div>
        <div class="typo-small app-space-right app-space-left">
          {{excSecurity.UserName}}
        </div>
        <div class="app-space-left">
          <i class="fal fa-ellipsis-v">
          </i>
        </div>
      </div>
    </div>
    <div class="content height-600 search-filter-seperator">
      <ng-container *ngIf="historyTable.state === 0">
        <ng-container *ngFor="let date of historyTable.historyDate; index as i">
          <div class="grid-auto-1-start app-space-top app-space-bottom">
            <ng-container *ngFor="let history of filteredDataList(date); index as i">
              <div [class.app-typo-hidden]="i !== 0" class="timeline-date typo-small width-100">
                {{date.histTimestamp_Date | excDate: getRessource('DateTimeFormat')}}
                <br>
                {{date.histTimestampDiff === 0 ? getRessource('today') :
                  getRessource('daysago', {days: date.histTimestampDiff})}}
              </div>
              <div class="timeline-element app-space-right tl-gray ">
                <ng-container *ngFor="let histValue of history.histValues; index as i">
                  <div class="grid cols-5 app-space-right app-space_025">
										<span class="typo-small">
											{{getKeyCaption(history.histObjectType, histValue.key)}}
										</span>

                    <span class="span-2 typo-small">
                           {{histValue.oldValue}}
                         </span>
                    <span class="span-2 typo-small">
                           {{histValue.newValue}}
                         </span>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="historyTable.state === 2 || historyTable.state === 1">
        <div *ngIf="historyTable.state === 1" class="splash loading">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div *ngIf="historyTable.state === 2" class="splash empty">
          <p>{{getRessource('zeroRows')}}</p>
        </div>
      </ng-container>

    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Close')}}
      </button>
    </div>
  </div>
</div>
